import { creditApi } from './creditApi';

export type CreditAccount = {
  userId: string;
  balance: number;
  unlimited: boolean;
};

export type CreditPolicyMode = 'charge' | 'unlimited';

export type CreditPolicy = {
  bizCode: string;
  mode: CreditPolicyMode;
};

export type CreditGrantRequest = {
  delta: number;
  reason: string;
  idempotencyKey: string;
};

export async function fetchCreditAccount(userId: string): Promise<CreditAccount> {
  const res = await creditApi.get<CreditAccount>(
    `/v1/credits/accounts/${encodeURIComponent(userId)}`,
  );
  return res.data;
}

export async function grantCredits(
  userId: string,
  body: CreditGrantRequest,
): Promise<CreditAccount> {
  const res = await creditApi.post<CreditAccount>(
    `/v1/credits/accounts/${encodeURIComponent(userId)}/grants`,
    body,
  );
  return res.data;
}

export async function setCreditUnlimited(
  userId: string,
  unlimited: boolean,
): Promise<CreditAccount> {
  const res = await creditApi.patch<CreditAccount>(
    `/v1/credits/accounts/${encodeURIComponent(userId)}`,
    { unlimited },
  );
  return res.data;
}

export async function fetchCreditPolicy(bizCode: string): Promise<CreditPolicy> {
  const res = await creditApi.get<CreditPolicy>(
    `/v1/credits/policies/${encodeURIComponent(bizCode)}`,
  );
  return res.data;
}

export async function upsertCreditPolicy(
  bizCode: string,
  mode: CreditPolicyMode,
): Promise<CreditPolicy> {
  const res = await creditApi.put<CreditPolicy>(
    `/v1/credits/policies/${encodeURIComponent(bizCode)}`,
    { mode },
  );
  return res.data;
}
